export const moveTo = (props) =>{
    const container = document.querySelector("div#svgContainer")
    const {x,y} = props
    const svg = container.querySelector("svg")
    const {width,height} = svg.getBoundingClientRect()
    container.scrollTop = y*height-container.getBoundingClientRect().height/2-20
    container.scrollLeft = x*width-container.getBoundingClientRect().width/2
    document.querySelector("#subMenu_waypoints").className = 'subMenu closed'
}